import json from "../json/billingAccountsJfrogaccAccountInfo.json";

export default async () => JSON.parse(JSON.stringify(await json));
